<template>
  <div class="welcome-view">
    <h1 class="welcome-view__title">Rating in progress</h1>
    <div class="welcome-view__image-container">
      <img src="/doria-science.png" alt="Doria Science" class="welcome-view__image" />
    </div>
  </div>
</template>

<style>
body, html {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
}

#app {
  height: 100%;
}
</style>

<style scoped>
.welcome-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  background: #f4e5b8;
  background-image:
    repeating-linear-gradient(
      0deg,
      transparent,
      transparent 2px,
      rgba(0,0,0,.02) 2px,
      rgba(0,0,0,.02) 4px
    );
}

.welcome-view__title {
  font-family: 'Cervo', sans-serif;
  font-size: 3rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 2rem;
  text-align: center;
  letter-spacing: -0.23px;
  text-transform: uppercase;
}

.welcome-view__image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background: linear-gradient(145deg, #8b6f47, #a0826d);
  border-radius: 4px;
  box-shadow:
    inset 0 2px 4px rgba(0,0,0,0.3),
    inset 0 -2px 4px rgba(255,255,255,0.1),
    0 4px 8px rgba(0,0,0,0.3);
  position: relative;
}

.welcome-view__image-container::before {
  content: '';
  position: absolute;
  inset: 8px;
  border: 2px solid rgba(139, 111, 71, 0.4);
  border-radius: 2px;
  pointer-events: none;
}

.welcome-view__image {
  max-width: 500px;
  width: 100%;
  height: auto;
  display: block;
  border-radius: 2px;
}

@media (max-width: 768px) {
  .welcome-view__title {
    font-size: 2rem;
  }

  .welcome-view__image {
    max-width: 100%;
  }
}
</style>
